import React, { useState, useRef, useEffect, useContext } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Layout from '@/product/components/templates/Layout'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import Loaders from '@/product/components/molecules/Loaders'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    FormControl,
    FormControlLabel,
    FormLabel,
    Menu,
    MenuItem,
    Radio,
    RadioGroup,
} from '@mui/material'
import './member.css'
import CheckBox from '@/product/components/atoms/CheckBox'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@emotion/react'
import CustomSelect from '@/product/components/atoms/Inputs/CustomSelect'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { mapData } from '@/product/common/components'
import NoRecordsFound from '@/product/components/atoms/NoRecordsFound'
import CardItem from './cardItem'
import BarCodeScan from '@/product/components/organisms/BarCodeScan'
import SettingContext from '@/product/context/setting/settingContext'
import ReturnContext from '@/custom/context/return/returnContext'
import AlertContext from '@/product/context/alert/alertContext'
import {
    capitalize,
    currencyFormat,
    dateTimeFormatFunction,
    isValidHttpUrl,
} from '@/custom/common/components'
import FormHelperText from '@mui/material/FormHelperText'
import RefundContext from '@/product/context/return/returnContext'
import AuthContext from '@/product/context/auth/authContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import SeeMoreLess from '@/product/components/molecules/SeeMoreLess/SeeMoreLess'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'

const StepOne = (props) => {
    const settingcontext = useContext(SettingContext)
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const refundContext = useContext(RefundContext)
    const {
        refundInvoiceStatus,
        responseStatus: responseStatusReturn,
        clearResponse: clearResponseReturn,
    } = refundContext
    const returncontext = useContext(ReturnContext)
    const {
        single_request,
        getSingleRequest,
        getUserRequestCount,
        updateRequest,
        responseStatus: responseStatusRequest,
        clearResponse: clearResponseRequest,
    } = returncontext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    const { alldata_all_dropdown, allCategory } =
        useContext(CustomCommonContext)

    const [isLoading, setIsLoading] = useState(true)
    const [userRecords, setUserRecords] = useState([])
    const [userText, setUserText] = useState({
        name: '',
        notPickedUp: 0,
        pickedUp: 0,
        pendingReturn: 0,
        refunded: 0,
        notes: '',
    })
    const [itemsRecords, setItemsRecords] = useState([])
    const [trnsactions, setTransactions] = useState([])
    const [returnTransactions, setReturnTransactions] = useState([])
    const [availableCardRefund, setAvailableCardRefund] = useState(0)
    const [anchorBreakEl, setAnchorBreakEl] = useState(false)
    const [open, setOpen] = useState(null)
    const [openApprove, setOpenApprove] = useState(null)
    const [initialStep, setInitialStep] = useState(true)
    const [stepOne, setStepOne] = useState(false)
    const [stepTwo, setStepTwo] = useState(false)
    const [denyActive, setDenyActive] = useState(false)
    const [moveDraft, setMoveDraft] = useState(false)
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [value, setValue] = React.useState('amount')
    const [productLocation, setProductLocation] = useState({})
    const [scanToggle, setScanToggle] = useState(false)
    const [scanType, setScanType] = useState('user')
    const [acceptDialog, setAcceptDialog] = useState(false)
    const [denyDialog, setDenyDialog] = useState(false)
    const [images, setImages] = useState([])
    const [isConfirming, setIsConfirming] = useState(false)

    const handleAcceptDialog = () => {
        setAcceptDialog(!acceptDialog)
        if (acceptDialog) {
            setIsConfirming(false)
        }
    }

    const handleDenyDialog = () => {
        setDenyDialog(!denyDialog)
    }

    const handleRadioChange = (event) => {
        setValue(event.target.value)
        formik.values.refundMethod =
            event.target.value === 'wallet' ? 'credit' : 'original'
    }

    const handleClickOpen = () => {
        setOpen(true)
        formik.values.return_request_status = 3
    }

    const handleApproveClickOpen = () => {
        formik.values.denyReturn = 0
        formik.values.return_request_status = 3

        if (formik.values.paidStatus === 1 && !formik.values.refundMethod) {
            setAlert('Refund Type is Required!', 'error')
            return
        }

        formik.handleSubmit()
    }

    const handleCancelOpen = () => {
        setOpen(false)
    }

    const handleDenyClickOpen = () => {
        formik.values.return_request_status = 4
        formik.values.denyReturn = 1
        formik.handleSubmit()
    }

    const handleClose = () => {
        setOpen(false)
        setOpenApprove(false)
    }

    const handleBreakClose = () => {
        setAnchorBreakEl(null)
    }
    const handleBreakClick = (event) => {
        setAnchorBreakEl(event.currentTarget)
    }
    const [expanded, setExpanded] = React.useState(
        props.defaultPanel ? props.defaultPanel : 'panel0'
    )

    const handleChange = (panel) => (event, newExpanded) => {
        if (panel === expanded) {
            setExpanded(false)
        } else setExpanded(panel)
    }
    const filterSections = [
        {
            name: 'pickedup_status',
            type: 'select',
            title: 'STATUS',
            search_type: 'checkbox',
            item: [
                { id: '', description: 'Not Picked Up' },
                { id: '', description: 'Picked Up' },
                { id: '', description: 'Pending Return' },
                { id: '', description: 'Refunded' },
            ],
        },
        {
            name: 'location',
            type: 'select',
            title: 'LOCATION',
            search_type: 'checkbox',
            filter: true,
            item: [{ id: '', description: 'Dallas' }],
        },
    ]

    const handlePendingReturn = () => {
        setStepOne(true)
        setInitialStep(false)
    }

    const handleMoveDraft = (event) => {
        event.currentTarget.classList.add('active')
        setOpen(true)
        setMoveDraft(true)
    }

    useEffect(() => {
        if (responseStatusRequest) {
            if (
                responseStatusRequest &&
                responseStatusRequest.from == 'updateRequest_deny'
            ) {
                setAlert(
                    responseStatusRequest.message,
                    responseStatusRequest.status
                )
                if (responseStatusRequest.status == 'success') {
                    setDenyDialog(false)
                    formik.handleReset()
                    props.closeOne()
                }
                setIsConfirming(false)
            } else if (
                responseStatusRequest &&
                responseStatusRequest.from == 'updateRequest_accept'
            ) {
                setAlert(
                    responseStatusRequest.message,
                    responseStatusRequest.status
                )
                if (responseStatusRequest.status == 'success') {
                    setAcceptDialog(false)
                    formik.handleReset()
                    props.closeOne('relist_open')
                }
                setIsConfirming(false)
            }
        }
        clearResponseRequest()
    }, [responseStatusRequest])

    const uploadImgArray = [
        {
            orgImg: '/assets/images/proImg.png',
            alt: 'proImg',
        },
        {
            orgImg: '/assets/images/proImg.png',
            alt: 'proImg',
        },
        {
            orgImg: '/assets/images/proImg.png',
            alt: 'proImg',
        },
    ]

    const validationArray = Yup.object({
        admin_comments: Yup.string().required('Required!'),
        project_id: Yup.number().positive().required('Required!'),
        // admin_images: Yup.array()
        //     .of(Yup.string().required('Each image must be a valid string.'))
        //     .min(1, 'At least one image is required.')
        //     .required('Required!'),
        // refundMethod: Yup.string().when('paidStatus', {
        //     is: (value) => value === 1,
        //     then: (schema) => schema.required('Required!'),
        //     otherwise: (schema) => schema.notRequired(),
        // }),
    })

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            return_reason: '',
            return_comments: '',
            return_images: [],
            admin_images: [],
            return_request_status: 0,
            admin_comments: '',
            id: 0,
            paidStatus: 0,
            denyReturn: 0,
            refundMethod: '',
            project_id: props.pid || 0,
            bid: props.bid || 0,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (denyDialog || acceptDialog) {
                setIsConfirming(true)
                updateRequest(
                    values,
                    values.return_request_status === 4
                        ? 'updateRequest_deny'
                        : values.return_request_status === 3
                        ? 'updateRequest_accept'
                        : 'updateRequest'
                )
            } else if (values.return_request_status === 4) {
                setDenyDialog(true)
            } else if (values.return_request_status === 3) {
                setAcceptDialog(true)
            }
        },
    })

    useEffect(() => {
        setIsLoading(false)
        // console.log(single_request, 'single_request')
        if (single_request && single_request.records.records.length) {
            let allRecords = single_request.records.records.length
                ? single_request.records.records[0]
                : []
            formik.values.id = single_request.records.records[0].return_id
            // formik.values.paidStatus = single_request.records.records[0]?.paid
            formik.setFieldValue(
                'paidStatus',
                single_request.records.records[0]?.paid
            )
            if (allRecords.uploadimages) {
                allRecords.uploadimages = allRecords.uploadimages
                    .toString()
                    .split(',')
            }
            setItemsRecords(allRecords)
            setTransactions(single_request.records.allTransactions)
            setReturnTransactions(
                single_request.records?.returnTransactions?.length
                    ? single_request.records?.returnTransactions
                    : []
            )
            const matchingTransaction =
                single_request.records?.allTransactions?.find(
                    (transaction) => transaction?.payment_method === 'Card'
                )

            if (matchingTransaction?.amount) {
                setAvailableCardRefund(
                    matchingTransaction.amount -
                        matchingTransaction?.refund_amount
                )
            }
        }
    }, [single_request])

    console.log('i asm dscbudvbjubv ', formik)

    useEffect(() => {
        if (responseStatusReturn) {
            if (responseStatusReturn.from == 'refundInvoiceStatus') {
                if (responseStatusReturn.status == 'success') {
                    updateRequest(formik.values, 'refundInvoice')
                    setOpen(false)
                    setOpenApprove(true)
                } else {
                    setAlert(
                        responseStatusReturn.message,
                        responseStatusReturn.status
                    )
                }
                clearResponseReturn()
            }
        }
    }, [responseStatusReturn])

    useEffect(() => {
        if (itemsRecords && Object.keys(itemsRecords).length) {
            formik.values.return_images =
                itemsRecords.return_images && itemsRecords.return_images !== ''
                    ? itemsRecords.return_images.toString().split(',')
                    : []
            formik.values.return_comments = itemsRecords.return_comments
            formik.setFieldValue('return_reason', itemsRecords.return_reason)
            formik.setFieldValue(
                'return_comments',
                itemsRecords.return_comments
            )
            console.log(itemsRecords, 'itemsRecords')
        }
    }, [itemsRecords])

    useEffect(() => {
        setItemsRecords([])
        setTransactions([])
        setReturnTransactions([])
        setAvailableCardRefund(0)
        setOpen(null)
        setInitialStep(true)
        setOpenApprove(null)
        setStepOne(false)
        setStepTwo(false)
        setDenyActive(false)
        setMoveDraft(false)
        setValue('amount')
        setProductLocation({})
        setScanType('user')
        setAcceptDialog(false)
        setDenyDialog(false)

        const initialValues = {
            return_request_status: '',
            return_reason: '',
            return_comments: '',
            return_images: [],
            admin_comments: '',
            refund_type: '',
            refund_amount: '',
            refund_invoice: '',
            refund_invoice_status: '',
            project_id: 0,
            bid: 0,
        }
        formik.resetForm(initialValues)

        if (props.pid || props?.bid) {
            formik.values.project_id = props.pid
            formik.values.bid = props.bid
            getSingleRequest({
                project_id: props.pid,
                bid: props.bid,
                common_invoice: props.cid,
            })
        }
    }, [props.bid])

    const fileValidationArray = Yup.object({
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
    })

    const fileFormik = useFormik({
        initialValues: {
            file_path: [],
        },
        validationSchema: fileValidationArray,
        onSubmit: (values) => {},
    })

    const changeScanDialogStatus = () => {
        fileFormik.resetForm()
        setScanToggle(!scanToggle)
    }

    const setDecodedBarcode = (data) => {
        console.log('i am scanned here ', scanType, data)
        if (data && data !== '') {
        }
    }

    const fileUpload = {
        formik: formik,
        data: [
            {
                type: 'uploadDropZone',
                name: 'return_images',
                titleText: 'Upload Product images*',
                class: 'col-12',
                folder: 'product',
                multiple: true,
                accept: 'image/*',
                disabled: true,
                disableEditing: true,
                disableDeleting: true,
            },
        ],
    }

    const fileUpload1 = {
        formik: formik,
        data: [
            {
                type: 'uploadDropZone',
                name: 'admin_images',
                titleText: 'Upload Product images*',
                class: 'col-12',
                folder: 'product',
                multiple: true,
                accept: 'image/*',
            },
        ],
    }

    const handleScanInput = (type) => {
        if (type === 'product') {
            setScanType('product')
        } else {
            setScanType('user')
        }
        setScanToggle(true)
    }

    useEffect(() => {
        if (itemsRecords) {
            let attachmentList = []

            if (Array.isArray(itemsRecords.uploadimages)) {
                attachmentList = itemsRecords.uploadimages
            } else if (
                itemsRecords?.uploadimages &&
                typeof itemsRecords.uploadimages === 'string' &&
                itemsRecords.uploadimages.trim() !== ''
            ) {
                attachmentList = itemsRecords.uploadimages.split(',')
            }

            const imagesArr = [
                // ...(itemsRecords.projects_avatar
                //     ? [
                //           {
                //               main: isValidHttpUrl(itemsRecords.projects_avatar)
                //                   ? itemsRecords.projects_avatar
                //                   : global.images_url +
                //                     itemsRecords.projects_avatar,
                //               original: isValidHttpUrl(
                //                   itemsRecords.projects_avatar
                //               )
                //                   ? itemsRecords.projects_avatar
                //                   : global.images_url +
                //                     itemsRecords.projects_avatar,
                //               thumbnail: isValidHttpUrl(
                //                   itemsRecords.projects_avatar
                //               )
                //                   ? itemsRecords.projects_avatar
                //                   : global.images_url +
                //                     itemsRecords.projects_avatar,
                //           },
                //       ]
                //     : []),
                ...attachmentList.map((data) => ({
                    main: isValidHttpUrl(data)
                        ? data
                        : global.images_url + data,
                    original: isValidHttpUrl(data)
                        ? data
                        : global.images_url + data,
                    thumbnail: isValidHttpUrl(data)
                        ? data
                        : global.images_url + data,
                })),
            ]

            setImages(imagesArr)
        } else {
            setImages([])
        }
    }, [itemsRecords?.uploadimages])

    return (
        <>
            <FullScreenPopup
                modaltitle={'Item Details'}
                open={props.open}
                handleClose={() => props.handleClose()}
            >
                <div className="addUserModal">
                    <div className="fspBody">
                        <div>
                            <div className="proImgList">
                                <div className="ProImg">
                                    {images?.map((data, index) => (
                                        <img
                                            key={`Image_${index}`}
                                            src={data.main}
                                            alt={`Image_${index}`}
                                            onError={(e) =>
                                                (e.target.src =
                                                    '/assets/images/noImg.png')
                                            }
                                        />
                                    ))}
                                </div>
                                <p className="tit">{itemsRecords.title}</p>
                                <div className="pvActBtn productDescr">
                                    <SeeMoreLess
                                        content={itemsRecords.desc_proc}
                                        // limit={500}
                                    />
                                </div>
                            </div>
                            <div className="text-left returnInfoListGet">
                                <Accordion
                                    className="ItemDetails mb-4"
                                    defaultExpanded
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <Typography>Item Details</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {parseInt(
                                            itemsRecords?.conditionTypeId,
                                            10
                                        ) && (
                                            <div className="pvDescChild">
                                                <label>Condition:</label>
                                                <h6>
                                                    {alldata_all_dropdown
                                                        .filter(
                                                            (values) =>
                                                                parseInt(
                                                                    values.id,
                                                                    10
                                                                ) ===
                                                                parseInt(
                                                                    itemsRecords?.conditionTypeId,
                                                                    10
                                                                )
                                                        )
                                                        .map(
                                                            (values) =>
                                                                values.description
                                                        )}
                                                </h6>
                                            </div>
                                        )}

                                        {itemsRecords?.color_size && (
                                            <div className="pvDescChild">
                                                <label>Color/Size:</label>
                                                <h6>
                                                    {itemsRecords?.color_size}
                                                </h6>
                                            </div>
                                        )}
                                        {itemsRecords?.scan_lpn_number && (
                                            <div className="pvDescChild">
                                                <label>LPN:</label>
                                                <h6>
                                                    {
                                                        itemsRecords?.scan_lpn_number
                                                    }
                                                </h6>
                                            </div>
                                        )}
                                        <div className="pvDescChild">
                                            <label>Item ID:</label>
                                            <h6>{itemsRecords?.id}</h6>
                                        </div>
                                        {itemsRecords?.material && (
                                            <div className="pvDescChild">
                                                <label>Material:</label>
                                                <h6>
                                                    {itemsRecords?.material}
                                                </h6>
                                            </div>
                                        )}

                                        {parseInt(
                                            itemsRecords?.category,
                                            10
                                        ) && (
                                            <div className="pvDescChild">
                                                <label>Category:</label>
                                                <h6>
                                                    {allCategory
                                                        .filter(
                                                            (values) =>
                                                                parseInt(
                                                                    values.id,
                                                                    10
                                                                ) ===
                                                                parseInt(
                                                                    itemsRecords?.category,
                                                                    10
                                                                )
                                                        )
                                                        .map(
                                                            (values) =>
                                                                values.description
                                                        )}
                                                </h6>
                                            </div>
                                        )}

                                        {(itemsRecords?.brand && (
                                            <div className="pvDescChild">
                                                <label>Brand:</label>
                                                <h6>{itemsRecords?.brand}</h6>
                                            </div>
                                        )) ||
                                            ''}

                                        {(parseInt(
                                            itemsRecords?.manufacturer,
                                            10
                                        ) && (
                                            <div className="pvDescChild f">
                                                <label>Manufacturer:</label>
                                                <h6>
                                                    {alldata_all_dropdown
                                                        .filter(
                                                            (values) =>
                                                                parseInt(
                                                                    values.id,
                                                                    10
                                                                ) ===
                                                                parseInt(
                                                                    itemsRecords?.manufacturer,
                                                                    10
                                                                )
                                                        )
                                                        .map(
                                                            (values) =>
                                                                values.description
                                                        )}
                                                </h6>
                                            </div>
                                        )) ||
                                            ''}
                                        {itemsRecords?.item_detail && (
                                            <div className="pvDescChild">
                                                <label>
                                                    Additional Details:
                                                </label>
                                                <h6>
                                                    {itemsRecords?.item_detail}
                                                </h6>
                                            </div>
                                        )}
                                    </AccordionDetails>
                                </Accordion>
                                <h3 className="mainTIt">
                                    CUSTOMER REQUEST TO RETURN
                                </h3>
                                <div className="formFields w-75 w-sm-100 customerReason">
                                    <label>Customer Reason :</label>
                                    <CustomInput
                                        label={``}
                                        type="text"
                                        placeholder="Defective / Doesn’t Work"
                                        name={'return_reason'}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.return_reason}
                                        disabled={true}
                                    />
                                </div>
                                <div className="formFields w-75 w-sm-100">
                                    <label>Customer Comments :</label>

                                    <CustomInput
                                        label={``}
                                        type="text"
                                        placeholder="The legs are missing on the grill. Plate is also cracked. I can’t use it."
                                        name={'return_comments'}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.return_comments}
                                        disabled={true}
                                    />
                                </div>
                                <div className="formFields w-100 w-sm-100">
                                    <label>Photos :</label>
                                    <div className="row">
                                        {mapData(fileUpload)}
                                    </div>

                                    {/* <div className="custerFIlteUpload">
                                    <CustomInput type="file" />
                                    <span>
                                        <p className="mb-2">
                                            Upload Product Image
                                        </p>
                                        <p className="mb-0">
                                            Recommended dimenstion 500px * 500px
                                        </p>
                                    </span>
                                </div> */}
                                </div>
                                {/* <div className="proImgList uploadIMg">
                                <div className="ProImg">
                                    <img
                                        src="/assets/images/proImg.png"
                                        className="img"
                                        alt="ProImg"
                                    ></img>
                                    <img
                                        src="/assets/images/proImg.png"
                                        className="img"
                                        alt="ProImg"
                                    ></img>
                                    <img
                                        src="/assets/images/proImg.png"
                                        className="img"
                                        alt="ProImg"
                                    ></img>
                                    <img
                                        src="/assets/images/proImg.png"
                                        className="img"
                                        alt="ProImg"
                                    ></img>
                                </div>
                            </div> */}

                                {/* {trnsactions?.length ? (
                                    <div className="formFields">
                                        <div className="font-weight-bold mb-4">
                                            Item Refundable Amount: {'  '}
                                            {currencyFormat(
                                                itemsRecords?.buynow_total_amount ||
                                                    0
                                            )}
                                        </div>
                                        <div className="d-flex mb-3">
                                            <div
                                                style={{ width: '200px' }}
                                                className="font-weight-bold"
                                            >
                                                Payment Type
                                            </div>
                                            <div className="font-weight-bold">
                                                Amount
                                            </div>
                                        </div>
                                        {trnsactions.map((item, index) => (
                                            <div
                                                key={index}
                                                className="d-flex align-items-start mb-3"
                                            >
                                                <div style={{ width: '200px' }}>
                                                    {item.payment_method ===
                                                    'Card' ? (
                                                        <>
                                                            CC{' '}
                                                            {
                                                                item.mk_card_number
                                                            }
                                                        </>
                                                    ) : (
                                                        capitalize(
                                                            item?.payment_method ||
                                                                'Unknown'
                                                        )
                                                    )}
                                                </div>
                                                <div>
                                                    {currencyFormat(
                                                        item.amount
                                                    )}
                                                    {'    '}
                                                    {item.payment_method ===
                                                    'Card' ? (
                                                        <span className="text-muted ms-2">
                                                            (Available Refund
                                                            Amount:{' '}
                                                            {currencyFormat(
                                                                item.amount -
                                                                    item?.refund_amount
                                                            )}
                                                            )
                                                        </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : null} */}

                                {trnsactions?.length ? (
                                    <>
                                        <div
                                            style={{ width: '200px' }}
                                            className="font-weight-bold invoiceSubTitle"
                                        >
                                            Payment Transactions
                                        </div>
                                        <div className="transDet d-flex justify-content-between flex-wrap">
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            {/* <th scope="col">S.No</th> */}
                                                            <th scope="col">
                                                                {
                                                                    'Transaction id'
                                                                }
                                                            </th>
                                                            <th scope="col">
                                                                {'Paid on'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Method'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Amount'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Status'}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {trnsactions.map(
                                                            (data, index) => (
                                                                <>
                                                                    <tr
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <td
                                                                            data-title={
                                                                                'Transaction id'
                                                                            }
                                                                        >
                                                                            {data.trans_id
                                                                                ? `# ${data.trans_id}`
                                                                                : '-'}
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                minWidth:
                                                                                    '112px',
                                                                            }}
                                                                            data-title={
                                                                                'Paid on'
                                                                            }
                                                                        >
                                                                            {dateTimeFormatFunction(
                                                                                data.created_at
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            data-title={
                                                                                'Card'
                                                                            }
                                                                        >
                                                                            {data.payment_method ===
                                                                            'Card' ? (
                                                                                <>
                                                                                    {capitalize(
                                                                                        data.payment_method
                                                                                    )}{' '}
                                                                                    -{' '}
                                                                                    {
                                                                                        data.mk_card_number
                                                                                    }{' '}
                                                                                    (
                                                                                    {
                                                                                        data.card_type
                                                                                    }

                                                                                    )
                                                                                </>
                                                                            ) : data.payment_method ===
                                                                              'Credit' ? (
                                                                                <>
                                                                                    Wallet
                                                                                </>
                                                                            ) : data.payment_method ===
                                                                              'coupon' ? (
                                                                                <>
                                                                                    Promo
                                                                                    Discount
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    {capitalize(
                                                                                        data.payment_method
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            data-title={
                                                                                'Amount'
                                                                            }
                                                                        >
                                                                            {currencyFormat(
                                                                                data.amount,
                                                                                2
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            data-title={
                                                                                'Payment status'
                                                                            }
                                                                            style={{
                                                                                color:
                                                                                    data.status ===
                                                                                    'success'
                                                                                        ? 'green'
                                                                                        : 'red',
                                                                            }}
                                                                        >
                                                                            {capitalize(
                                                                                data.status ===
                                                                                    'success'
                                                                                    ? 'Paid'
                                                                                    : 'UnPaid'
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </>
                                ) : null}

                                {returnTransactions?.length ? (
                                    <>
                                        <div
                                            style={{ width: '200px' }}
                                            className="font-weight-bold invoiceSubTitle"
                                        >
                                            Refund Transactions
                                        </div>
                                        <div className="transDet d-flex justify-content-between flex-wrap">
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">
                                                                {'Refund id'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Refund on'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Amount'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Method'}
                                                            </th>
                                                            <th scope="col">
                                                                {
                                                                    'Refund Status'
                                                                }
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {returnTransactions.map(
                                                            (data, index) => (
                                                                <tr key={index}>
                                                                    <td
                                                                        data-title={
                                                                            'Transaction id'
                                                                        }
                                                                    >
                                                                        {data.reftrans_id
                                                                            ? `# ${data.reftrans_id}`
                                                                            : 'Wallet Refund'}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            minWidth:
                                                                                '112px',
                                                                        }}
                                                                        data-title={
                                                                            'Refund on'
                                                                        }
                                                                    >
                                                                        {dateTimeFormatFunction(
                                                                            data.created_at
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Amount'
                                                                        }
                                                                    >
                                                                        {currencyFormat(
                                                                            data.amount,
                                                                            2
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Method'
                                                                        }
                                                                    >
                                                                        {data?.refund_method ===
                                                                        'stripe'
                                                                            ? 'Card'
                                                                            : 'Wallet'}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Refund status'
                                                                        }
                                                                        style={{
                                                                            color:
                                                                                data.status ===
                                                                                'success'
                                                                                    ? 'green'
                                                                                    : 'red',
                                                                        }}
                                                                    >
                                                                        {capitalize(
                                                                            data.status ===
                                                                                'success'
                                                                                ? 'Success'
                                                                                : 'Failed'
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </>
                                ) : null}

                                <div className="transDet d-flex justify-content-between flex-wrap">
                                    <table className="table table-bordered table-responsive">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    {'Item Refund Details'}
                                                </th>
                                                <th scope="col">{'Amount'}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th>Total Amount:</th>
                                                <td>
                                                    {currencyFormat(
                                                        itemsRecords?.buynow_total_amount ||
                                                            0
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th className="text-muted">
                                                    Applied Promo Discount
                                                    Amount (Promo Discount
                                                    Amount can&#39;t be
                                                    refunded):
                                                </th>
                                                <td className="text-muted">
                                                    {currencyFormat(
                                                        itemsRecords?.coupon_discount ||
                                                            0
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    Available Card Refund
                                                    Amount:
                                                </th>
                                                <td>
                                                    {currencyFormat(
                                                        itemsRecords?.card_discount ||
                                                            0
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    Available Wallet Refund
                                                    Amount:
                                                </th>
                                                <td>
                                                    {currencyFormat(
                                                        itemsRecords?.credit_discount ||
                                                            0
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    Total Refundable Amount:
                                                </th>
                                                <td>
                                                    {itemsRecords?.refundable_amount
                                                        ? currencyFormat(
                                                              itemsRecords?.refundable_amount
                                                          )
                                                        : currencyFormat(
                                                              (
                                                                  parseFloat(
                                                                      itemsRecords?.card_discount ||
                                                                          0
                                                                  ) +
                                                                  parseFloat(
                                                                      itemsRecords?.credit_discount ||
                                                                          0
                                                                  )
                                                              ).toFixed(2)
                                                          )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="radioSected mt-4">
                                    <label className="forLabel d-flex justify-content-start align-items-center">
                                        Select Refund Type :
                                        {!itemsRecords?.paid && (
                                            <div className="d-flex justify-content-center align-items-center ml-unpaid ml-3">
                                                <small className="short-tiny">
                                                    <span className="material-icons-outlined mr-1"></span>
                                                    Unpaid
                                                </small>
                                            </div>
                                        )}
                                    </label>
                                    <FormControl>
                                        <RadioGroup
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            value={formik.values.refundMethod}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            name="refundMethod"
                                            disabled={
                                                formik.values.paidStatus === 0
                                            }
                                        >
                                            <FormControlLabel
                                                value="original"
                                                control={<Radio />}
                                                label="Original Payment Methods"
                                                disabled={
                                                    formik.values.paidStatus ===
                                                    0
                                                }
                                                sx={
                                                    formik.values.paidStatus ===
                                                    0
                                                        ? {
                                                              '&.Mui-disabled':
                                                                  {
                                                                      color: 'rgba(0, 0, 0, 0.38)',
                                                                  },
                                                          }
                                                        : {}
                                                }
                                            />
                                            <FormControlLabel
                                                value="credit"
                                                control={<Radio />}
                                                label="New Wallet Credit"
                                                disabled={
                                                    formik.values.paidStatus ===
                                                    0
                                                }
                                                sx={
                                                    formik.values.paidStatus ===
                                                    0
                                                        ? {
                                                              '&.Mui-disabled':
                                                                  {
                                                                      color: 'rgba(0, 0, 0, 0.38)',
                                                                  },
                                                          }
                                                        : {}
                                                }
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                    <div className="checkboxError">
                                        <FormHelperText>
                                            {formik.errors.refundMethod &&
                                                formik.touched.refundMethod &&
                                                formik.errors.refundMethod}
                                        </FormHelperText>
                                    </div>
                                </div>
                                <div className="formFields w-75 w-sm-100 textArea">
                                    <label>Staff Notes :</label>
                                    <CustomInput
                                        label={``}
                                        type="text"
                                        placeholder="Staff Notes"
                                        name={'admin_comments'}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.admin_comments}
                                    />
                                    <div className="checkboxError">
                                        <FormHelperText>
                                            {formik.errors.admin_comments &&
                                                formik.touched.admin_comments &&
                                                formik.errors.admin_comments}
                                        </FormHelperText>
                                    </div>
                                </div>
                                <div className="formFields w-100 w-sm-100">
                                    <label>Photos :</label>
                                    <div className="row">
                                        {mapData(fileUpload1)}
                                    </div>
                                </div>
                            </div>

                            <div className="itesBtnGrp">
                                <Button
                                    onClick={() => handleApproveClickOpen()}
                                    className="PrimaryButton"
                                >
                                    Approve
                                </Button>
                                <Button
                                    className="SecondaryButton"
                                    onClick={() => handleDenyClickOpen()}
                                >
                                    Deny
                                </Button>
                            </div>
                        </div>

                        <Dialog
                            fullScreen={fullScreen}
                            open={acceptDialog}
                            onClose={handleAcceptDialog}
                            className={`returnflowDialog`}
                        >
                            <DialogContent className="p-0">
                                <DialogContentText>
                                    By clicking confirm, you are{' '}
                                    <strong>approving</strong> the return and
                                    processing a refund for this item.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="justify-content-center mt-3">
                                <Button
                                    type="submit"
                                    className="PrimaryButton"
                                    onClick={() => {
                                        formik.handleSubmit()
                                    }}
                                    disabled={isConfirming}
                                >
                                    {isConfirming ? 'Confirming...' : 'Confirm'}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            fullScreen={fullScreen}
                            open={denyDialog}
                            onClose={handleDenyDialog}
                            className={`returnflowDialog`}
                        >
                            <DialogContent className="p-0">
                                <DialogContentText>
                                    By clicking confirm, you are{' '}
                                    <strong>denying</strong> the return. Your
                                    staff note will be sent to the customer.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className="justify-content-center mt-3">
                                <Button
                                    type="submit"
                                    className="PrimaryButton"
                                    onClick={() => {
                                        formik.handleSubmit()
                                    }}
                                >
                                    Confirm
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            fullScreen={fullScreen}
                            open={open}
                            onClose={handleClose}
                            className={`returnflowDialog approved'}`}
                        >
                            <DialogContent className="p-0">
                                <div className="text-center">
                                    <svg
                                        width="69"
                                        height="69"
                                        viewBox="0 0 69 69"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="mb-4"
                                    >
                                        <g clipPath="url(#clip0_26_161)">
                                            <path
                                                d="M34.36 0C39.6897 0 44.7334 1.21422 49.24 3.37996C47.3954 4.83935 45.6849 6.24037 44.0913 7.58885C41.0557 6.48555 37.7809 5.88428 34.3659 5.88428C26.5026 5.88428 19.3808 9.0716 14.232 14.2262C9.07745 19.3808 5.89012 26.4968 5.89012 34.36C5.89012 42.2232 9.07745 49.3392 14.232 54.4938C19.3866 59.6484 26.5026 62.8357 34.3659 62.8357C42.2291 62.8357 49.3509 59.6484 54.4997 54.4938C59.6543 49.3392 62.8416 42.2232 62.8416 34.36C62.8416 32.492 62.6606 30.659 62.3162 28.8902C63.7931 26.9638 65.3051 25.0432 66.852 23.1402C68.0662 26.6544 68.7259 30.4313 68.7259 34.36C68.7259 43.8461 64.8789 52.439 58.6619 58.656C52.4449 64.873 43.8519 68.72 34.3659 68.72C24.8798 68.72 16.2869 64.873 10.0698 58.656C3.84697 52.439 0 43.8461 0 34.36C0 24.8739 3.84697 16.281 10.064 10.064C16.281 3.84697 24.874 0 34.36 0ZM18.3534 28.7151L26.7361 28.6041L27.3608 28.7676C29.0537 29.7425 30.6473 30.8575 32.1359 32.1184C33.21 33.029 34.2374 34.0214 35.2123 35.0955C38.2187 30.2562 41.4235 25.8138 44.8093 21.7275C48.5162 17.2501 52.4507 13.1871 56.5837 9.48023L57.401 9.165H66.5485L64.7038 11.214C59.0355 17.5127 53.8926 24.0216 49.2459 30.7349C44.5992 37.4539 40.4428 44.389 36.7476 51.5283L35.5976 53.7466L34.541 51.4875C32.5912 47.3019 30.2562 43.4608 27.4717 40.0283C24.6871 36.5958 21.4473 33.5486 17.6704 30.9567L18.3534 28.7151Z"
                                                fill="#01A601"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_26_161">
                                                <rect
                                                    width="68.72"
                                                    height="68.72"
                                                    fill="white"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <DialogContentText>
                                        <strong>Return Approved</strong>
                                    </DialogContentText>
                                </div>
                            </DialogContent>
                        </Dialog>

                        <BarCodeScan
                            scanToggle={scanToggle}
                            changeScanDialogStatus={changeScanDialogStatus}
                            setDecodedBarcode={setDecodedBarcode}
                        />
                    </div>
                </div>
            </FullScreenPopup>
        </>
    )
}
export default StepOne
